import BasicRouterView from "../../components/BasicRouterView.vue";

const usuarioNovo = {
  path: "usun",
  name: "",
  redirect: { name: "usuarios" },
  meta: {
    label: "Usuários Novo",
    icon: "business_center",
    show: true,
    favorite: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "lista-usuarios",
      name: "usun-lista-usuarios",
      meta: {
        label: "Lista Usuários",
        icon: "business",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "usun" */ "./views/ListaUsuarios.vue"),
    },
    {
      path: "cadastrar-usuario",
      name: "usun-cadastrar-usuario",
      meta: {
        label: "Cadastrar Usuário",
        icon: "business",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "usun" */ "./views/CadastrarUsuario.vue"),
    },
    {
      path: "detalhe-usuario/:id",
      name: "usun-detalhe-usuario",
      meta: {
        label: "Detalhe Usuário",
        icon: "business",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "usun" */ "./views/DetalheUsuario.vue"),
    },
  ],
};

export default usuarioNovo;
